/* eslint-disable */
export default {
    LOG_OUT: 'Odhlásit se',
    LOGIN: 'Přihlášení',
    GET_A_MAP_EXPERT: 'Získejte mapového experta',
    MY_ACCOUNT: 'Můj účet',
    MY_ACCOUNT_DESC: 'Můžete změnit svá nastavení',
    SUBSCRIPTION: 'Předplatné',
    PASSWORD: 'Heslo',
    LANGUAGE: 'Jazyk',
    AVAILABLE_LANGUAGES: 'Dostupné jazyky',
    YOU_HAVE_NO_PASSWORD: 'Nemáte heslo',
    YOU_HAVE_NAME: 'Používáte {0} verzi Mapheimu',
    SUBSCRIBE_ACTION: 'Předplatit',
    MANAGE_SUBSCRIPTION: 'Spravovat předplatné',
    CANCELLED_SUBSCRIPTION: 'Vaše předplatné bylo zrušeno a bude deaktivováno na konci vašeho účtovacího období',
    RENEW_SUBSCRIPTION: 'Obnovit předplatné',
    RESUBSCRIBE: 'Znovu předplatit',
    VIEW_PAST_INVOICES: 'Zobrazit minulé faktury',
    SUBSCRIBE_NOT_PAID: 'Vaše předplatné se nepodařilo zaplatit. Zkontrolujte své platební údaje a opakujte platbu',
    REVIEW_PAYMENT: 'Zkontrolovat platbu',
    YOUR_MAPS: 'Vaše mapy',
    EDIT_CONTENT: 'Upravit obsah',
    ADVANCED_EDITOR: 'Pokročilý editor',
    CUSTOM_URL: 'Vlastní URL',
    UNNAMED_MAP: 'Nepojmenovaná mapa',
    EDIT: 'Upravit',
    WELCOME: 'Vítejte',
    WELCOME_DESC: 'Užijte si práci s vašimi mapami!',
    DO_YOU_WANT_NEW_MAP: 'Chcete novou mapu?',
    UPGRADE_ACTION: 'Vylepšit',
    CREATE_ACTION: 'Vytvořit',
    UPGRADE_EXPERIENCE: 'Vylepšete si svůj zážitek',
    UPGRADE_EXPERIENCE_DESC: 'Získejte více ze svých map',
    NEED_HELP: 'Potřebujete pomoc?',
    LET_US_KNOW: 'Dejte nám vědět',
    CONTACT_ACTION: 'Kontakt',
    MO: 'měs.',
    SUB1: 'Tvůrce',
    SUB1_DESC: 'Pro nadšené tvůrce',
    VIEWS_PER_MONTH: '{0} zobrazení / měsíc',
    MARKERS_PER_MAP: '{0} značek / mapa',
    X_MAPS: '{0} map',
    DEDICATED_SUPPORT: 'Vyhrazená podpora',
    MANAGE_ACTION: 'Spravovat',
    DOWNGRADE_ACTION: 'Zhoršit',
    SUB2: 'Pro',
    SUB2_DESC: 'Pro profesionální použití',
    UNLIMITED_MARKERS: 'Neomezený počet značek',
    UNLIMITED_MAPS: 'Neomezený počet map',
    SUB3: 'Vlastní',
    SUB3_DESC: 'Pro jakékoli mapové potřeby',
    SUB3_TEXT1: 'Potřebujete více zobrazení, speciální funkce nebo pomoc s vytvořením mapy?',
    SUB3_TEXT2: 'Vytvořili jsme mapy pro zábavní parky, konference, cestovní ruch, festivaly a mnoho dalších odvětví. Dejte nám vědět',
    CONTACT_US: 'Kontaktujte nás',
    PREVIEW_MAP: 'Náhled mapy',
    SHARE_ACTION: 'Sdílet',
    GET_ACCESS: 'Získat přístup',
    LOGIN_TO_BECOME: 'Přihlaste se, abyste se stali skutečným tvůrcem map nebo',
    CREATE_A_MAP: 'vytvořte si mapu',
    AS_A_GUEST: 'jako host',
    REGISTER_CREATOR: 'Zaregistrujte se, abyste se stali skutečným tvůrcem map',
    REGISTRATION: 'Registrace',
    USING_SOCIALS: 'Použití sociálních sítí',
    USING_MAIL: 'Použití e-mailu',
    EMAIL_OR_USER: 'Email nebo uživatelské jméno',
    FORGOT_PASSWORD: 'Zapomenuté heslo',
    LOGIN_ACTION: 'Přihlásit se',
    ERROR_USER_NOT_FOUND: 'Uživatel nebyl nalezen',
    ERROR_WRONG_PASSWORD: 'Špatné heslo',
    ERROR_USER_BANNED: 'Uživatel zablokován',
    ERROR_EMAIL_NOT_VERIFIED: 'Email není ověřen',
    ERROR_LOGIN: 'Chyba při přihlašování',
    VERIFICATION_SENT1: 'Ověřovací odkaz byl odeslán na vaši e-mailovou adresu',
    VERIFICATION_SENT2: 'Zkontrolujte svou doručenou poštu a složku spam a klikněte na odkaz, abyste dokončili registraci',
    EMAIL: 'Email',
    CONFIRM_PASSWORD: 'Potvrďte heslo',
    INVALID_EMAIL: 'Email není platný',
    PASSWORD_NOT_STRONG: 'Nové heslo není dostatečně silné nebo hesla nejsou stejná. Musí mít alespoň 6 znaků',
    EMAIL_USED: 'Uživatel s tímto e-mailem je již registrován',
    ERROR_REGISTRATION: 'Chyba při registraci nového uživatele',
    MAP_NOT_ACCESSIBLE: 'K této mapě nelze přistupovat',
    MAP_NOT_ACCESSIBLE_DESC: 'Kontaktujte prosím majitele mapy, aby byla mapa znovu dostupná',
    RETRIEVE_ACCESS: 'Získat přístup',
    RETRIEVE_ACCESS_DESC: 'Změňte heslo, abyste se stali skutečným tvůrcem map',
    SEND_RESET_LINK_ACTION: 'Odeslat odkaz',
    RESET_LINK_SENT: 'E-mail s odkazem na obnovení byl odeslán na vaši e-mailovou adresu. Zkontrolujte svou doručenou poštu a složku spam',
    ERROR_SENT_LINK: 'Chyba při odesílání odkazu pro obnovení',
    EMAIL_VERIFIED: 'E-mail ověřen',
    EMAIL_VERIFIED_DESC: 'Přihlaste se a začněte vytvářet',
    RESET_PASSWORD: 'Změnit heslo',
    RESET_PASSWORD_DESC: 'Změňte heslo, abyste se stali skutečným tvůrcem map',
    INVALID_LINK: 'Neplatný odkaz',
    ERROR_RESET_CODE: 'Kód pro obnovení vypršel. Pošlete prosím nový kód pro obnovení',
    ERROR_RESETTING: 'Chyba při nastavení nového hesla',
    NEW_PASSWORD: 'Nové heslo',
    SET_NEW_PASSWORD: 'Nastavit nové heslo',
    HEADER: 'Hlavička',
    NO_HEADER: 'Bez hlavičky',
    TITLE: 'Nadpis',
    DESCRIPTION: 'Popis',
    SELECT_ACTION: 'Vybrat',
    CONTENT: 'Obsah',
    CONTENT_DESC: 'Můžete také přidat různé karty obsahu do svého značení (doporučeno)',
    POST_URL: 'URL příspěvku',
    POST_ID: 'ID příspěvku',
    VIDEO_URL: 'URL videa',
    ADD_FIRST_CARD: 'Přidejte první kartu',
    LINK: 'Odkaz',
    CONFIRM_DELETE_LINK: 'Chcete tento odkaz smazat?',
    ADD_LINK: 'Přidat odkaz',
    ADD_ANOTHER_LINK: 'Přidat další odkaz',
    NAME: 'Název',
    TYPE: 'Typ',
    GUIDE: 'Průvodce',
    OLD_GUIDE: 'Starý průvodce',
    SHARE_THE_LINK: 'Sdílet odkaz',
    COPY_MAP_ID: 'ID mapy pro Wordpress Plugin',
    COPY_MAP_ID_ACTION: 'Zkopírovat ID mapy',
    COPY_MAP_ID_CLIPBOARD: 'ID mapy zkopírováno do schránky',
    LINK_COPIED_CLIPBOARD: 'Odkaz zkopírován do schránky',
    GUIDE_COLORS_ACCENT1: 'Hlavní barva',
    CUSTOM: 'Vlastní',
    SAVE: 'Uložit',
    ALL_SAVED: 'Vše uloženo',
    COPY_URL_ACTION: 'Zkopírovat URL',
    GENERATE_QR_CODE: 'Vygenerovat QR kód',
    DOWNLOAD_QR_ACTION: 'Stáhnout QR',
    EMBED_ON_YOUR_SITE: 'Vložit na váš web',
    COPY_HTML_ACTION: 'Zkopírovat HTML',
    HTML_COPIED_CLIPBOARD: 'HTML zkopírován do schránky',
    HISTORY: 'Historie',
    MARKERS: 'Značky',
    LOCATION: 'Poloha',
    LOADING: 'Načítání',
    NOTHING_FOUND: 'Nic nenalezeno',
    PLEASE_WRITE_CHARACTERS: 'Prosím napište alespoň 3 znaky',
    MOUSE: 'Myš',
    PIN: 'Značka',
    IMAGE: 'Obrázek',
    TEXT: 'Text',
    DRAW: 'Kresba',
    DIRECTION: 'Trasa',
    LINE: 'Čára',
    POLYGON: 'Polygon',
    WALL_LINE: '3D Zeď',
    WALL_FILL: '3D Zeď (Vyplněná)',
    REACT: 'React',
    CHATGPT: 'ChatGPT',
    UPLOAD_ACTION: 'Nahrát',
    PROPERTIES: 'Vlastnosti',
    INTERACTIVITY: 'Interaktivita',
    MAP_SETTINGS: 'Nastavení mapy',
    PRIVACY: 'Soukromí',
    PRIVACY_DESC: 'Soukromé mapy nelze sdílet s nikým',
    GPS_POSITION: 'GPS pozice',
    ENABLED: 'Aktivováno',
    DISABLED: 'Deaktivováno',
    BUBBLE_DESC: 'Kliknutím na interaktivní značku se zobrazí bublina. Doporučeno pro minimální množství obsahu',
    MINI_DESC: 'Kliknutím na interaktivní značku se zobrazí vyskakovací okno. Doporučeno pro malé množství obsahu',
    STYLE1_DESC: 'Kliknutím na interaktivní značku se zobrazí postranní panel. Doporučeno pro libovolné množství obsahu',
    PANEL: 'Panel',
    POPUP: 'Okno',
    BUBBLE: 'Bublina',
    PUBLIC: 'Veřejné',
    PRIVATE: 'Soukromé',
    MAP_STYLE: 'Styl mapy',
    FILL_COUNTRIES: 'Vyplnit země',
    REGISTER_PROMPT: 'Zaregistrujte se, abyste mohli svou mapu uložit',
    GET_MORE_PROMPT: 'Získejte více návštěv a neomezené množství značek přechodem na režim Pro',
    CONTACT_PROMPT: 'Chcete přístup k pokročilému editoru nebo potřebujete ještě více návštěv?',
    UNLOCK_PROMPT: 'Odemkněte všechny funkce a zvyšte návštěvnost mapy v režimu Creator nebo Pro',
    UPGRADE: 'Vylepšit',
    MAP_VISITS_LIMIT: 'Omezení návštěv mapy',
    MARKER_LIMIT: 'Omezení značek',
    ADVANCED_EDITOR_ACCESS: 'Přístup k pokročilému editoru',
    REGISTER_ACTION: 'Registrovat se',
    NO: 'Ne',
    YES: 'Ano',
    SYMBOL: 'Symbol',
    YOUR_IMAGE: 'Váš obrázek',
    SEARCH: 'Hledat',
    SEARCH_ON_MAP: 'Hledat na mapě',
    MORE: 'Více',
    BACKGROUND: 'Pozadí',
    CONTROLS: 'Ovládání',
    CLONE: 'Klonovat',
    ORDER: 'Pořadí',
    TOP: 'Nahoru',
    BOTTOM: 'Dolů',
    EMOJI: 'Emoji',
    SEARCH_GIFS: 'Hledat GIFy',
    DELETE: 'Smazat',
    TRANSPORTATION: 'Doprava',
    COORDINATES: 'Souřadnice',
    POINT_X: 'Bod {0}',
    POSITION: 'Pozice',
    GROUND_COLOR: 'Podlaha',
    STYLE: 'Styl',
    COLOR: 'Barva',
    SIZE: 'Velikost',
    POSITION_DESC: 'Klikněte kdekoli na mapě pro změnu pozice',
    TRANSFORM: 'Transformovat',
    ROTATE: 'Otočit',
    SCALE: 'Měřítko',
    BORDER_SIZE: 'Velikost okraje',
    OPACITY: 'Průhlednost',
    BORDER_COLOR: 'Barva okraje',
    DASHED: 'Čárkování',
    HEIGHT: 'Výška',
    BASE_HEIGHT: 'Výška základny',
    WIDTH: 'Šířka',
    DIRECTION_ADD1: 'Klikněte kdekoli na mapě pro nastavení počátečního bodu nebo vyhledejte adresu',
    DIRECTION_ADD2: 'Klikněte znovu pro nastavení cíle nebo vyhledejte adresu (nebo Esc pro zrušení)',
    ICON_ADD: 'Klikněte kdekoli na mapě nebo vyhledejte adresu pro přidání značky. Značka si vždy udržuje stejnou velikost',
    VARIANT_ICON_ADD: 'Klikněte kdekoli na mapě nebo vyhledejte adresu pro přidání značky. Značka si udržuje stejnou velikost, ale její styl se mění podle úrovně přiblížení',
    IMAGE_ADD: 'Klikněte kdekoli na mapě pro nahrání obrázku nebo přetáhněte jeden ze symbolů nebo obrázků z galerie',
    TEXT_ADD: 'Klikněte kdekoli na mapě pro přidání textu',
    LINE_ADD: 'Začněte klikat na mapě pro nakreslení čáry. Stiskněte Enter pro dokončení (nebo Esc pro zrušení)',
    POLYGON_ADD: 'Začněte klikat na mapě pro nakreslení polygonu. Stiskněte Enter pro dokončení (nebo Esc pro zrušení)',
    WALL_ADD: 'Začněte klikat na mapě pro nakreslení 3D zdi. Stiskněte Enter pro dokončení (nebo Esc pro zrušení)',
    ADDRESS_SEARCH: 'Vyhledávání adresy',
    STARTING_POINT: 'Počáteční bod',
    DESTINATION: 'Cíl',
    GALLERY: 'Galerie',
    POLYGON_ADD2: 'Polygony lze udělat neviditelné a stále spouštět akce po kliknutí (Výhodné zejména pro mapy obrázků)',
    ZOOM_IN_MORE: 'Přiblížte se více pro nakreslení zdi',
    LABEL: 'Štítek',
    ICON: 'Ikona',
    INTERACTIVITY_PROMPT: 'Definujte, co lidé uvidí, když kliknou na značku',
    CREATE_INTERACTIVITY_ACTION: 'Vytvořit interaktivitu',
    CONFIRM_SAVE: 'Chcete uložit změny?',
    CONFIRM_REMOVE_INTERACTIVITY: 'Chcete odebrat tuto interaktivitu?',
    SAVING: 'Ukládání',
    REFRESH_PREVIEW: 'Obnovit náhled',
    SHOW_PREVIEW: 'Zobrazit náhled',
    REMOVE_INTERACTIVITY: 'Odebrat interaktivitu',
    MAX_LENGTH_TEXT_MARKER: 'Dosáhli jste maximální délky textu 1000 znaků',
    MAP_ROTATION: 'Rotace mapy',
    PITCH_ANGLE: 'Úhel náklonu (pouze pro zobrazení)',
    GPX_FILE: 'GPX soubor',
    GPX_UPLOAD_MESSAGE: 'Nahrajte svůj soubor GPX vpravo. Pokud soubor není podporován, napište nám zprávu',
    EXPERIMENTAL_FEATURES_MESSAGE: 'Můžete aktivovat experimentální funkce. Toto je určeno pouze pro zkušené tvůrce a testery',
    EXPERIMENTAL: 'Experimentální',
    LATITUDE: 'Šířka',
    LONGITUDE: 'Délka',
    FILE_UPLOAD: 'Nahrání souboru',
    UNKNOWN_GPX_FILE: 'Neznámý formát souboru GPX',
    OPEN_GALLERY: 'Otevřít galerii',
    GALLERY_ALL: 'Vše',
    GALLERY_YOUR_IMAGES: 'Vaše obrázky',
    GALLERY_CATEGORY_IMAGES: 'Obrázky kategorie',
    GALLERY_NATURE: 'Příroda',
    GALLERY_ANIMALS: 'Zvířata',
    GALLERY_VEHICLES: 'Vozidla',
    GALLERY_BUILDINGS: 'Budovy',
    GALLERY_FLAGS: 'Vlajky',
    USE_COMPUTER: 'Pro tvorbu map použijte počítač',
    USE_COMPUTER_DESC: 'Editor map není optimalizován pro mobilní zařízení, použijte prosím větší obrazovku. Nemějte strach, všechny mapy vytvořené prostřednictvím editoru skvěle fungují na mobilních zařízeních.',
    CONTINUE_ANYWAY: 'Přesto pokračovat',
    GO_TO_HOMEPAGE: 'Přejít na domovskou stránku',
    DELETE_MAP: 'Smazat mapu',
    ADD_FLOOR: 'Přidat podlaží',
    FLOORS: 'Podlaží',
    FLOOR_NR: 'Podlaží č.',
    ADD_CATEGORY: 'Přidat kategorii',
    CATEGORIES: 'Kategorie',
    CATEGORY_NR: 'Kategorie č.',
    VISIBLE_ON_LOAD: 'Viditelné při načtení',
    DELETE_MAP_CONFIRM: 'Opravdu chcete smazat tuto mapu?',
    DELETE_FLOOR_CONFIRM: 'Opravdu chcete smazat toto podlaží?',
    DELETE_CATEGORY_CONFIRM: 'Opravdu chcete smazat tuto kategorii?',
    STAND: 'Stánek',
    CLICK_ANYWHERE_TO_STAND: 'Klikněte kdekoli pro přidání stánku',
    MAP_DELETED: 'Mapa smazána',
    PIN_IMAGE: 'Obrázek značky',
    LOGO_IMAGE: 'Obrázek loga',
    FILLING: 'Výplň',
    FILLING1: 'Tato možnost zobrazuje pouze 3D zeď. Poslední bod nemusí být připojen k prvnímu',
    FILLING2: 'Tato možnost zobrazuje 3D zeď a podlahu. Automaticky uzavírá oblast',
    FILLING3: 'Tato možnost vytváří 3D strukturu. Automaticky uzavírá oblast',
    BOOKING: 'Rezervace',
    DELETE_BOOKING: 'Smazat rezervaci',
    DELETE_BOOKING_CONFIRM: 'Opravdu chcete smazat tuto rezervaci? Tuto akci nelze vrátit zpět.',
    BOOKING_FIELD_TYPE_CHECKBOX: 'Ano/Ne',
    BOOKING_FIELD_TYPE_TEXT: 'Text',
    BOOKING_FIELD_TYPE_EMAIL: 'Email',
    BOOKING_EMPTY_INFO: 'Zatím neexistuje žádná rezervace. Níže můžete vidět pole, která se sbírají.',
    FIELD_REQUIRED: 'Toto pole je povinné',
    BOOKING_SUBMIT: 'Vytvořit rezervaci',
    BOOKING_SUCCESS_TITLE: 'Vaše rezervace je potvrzena',
    BOOKING_SUCCESS_MESSAGE: 'Děkujeme za vaši rezervaci. Na váš e-mail dorazí potvrzovací e-mail. Pokud e-mail v doručené poště neuvidíte,',
    BOOKING_SUCCESS_MESSAGE_CHECK_SPAM: 'zkontrolujte prosím složku spam.',
    BOOKING_FAILED_TITLE: 'Vaše rezervace se nepodařilo vytvořit',
    BOOKING_FAILED_MESSAGE: 'Vypadá to, že tento stánek před vámi někdo zarezervoval. Obnovte prosím stránku a vyberte ze seznamu stánek, který je v současné době k dispozici. Volné stánky jsou označeny zeleně.',
    BOOKING_FULL_TITLE: 'Tento stánek je již zarezervován',
    BOOKING_FULL_MESSAGE: 'Vyberte prosím ze seznamu stánek, který je v současné době k dispozici. Volné stánky jsou označeny zeleně.',
    BOOKING_CLOSE_DIALOG: 'Zavřít dialog',
    BOOKING_SEE_OTHER_STANDS: 'Zobrazit mapu',
    OR: 'nebo',
    SEARCH_DETAIL_PLACEHOLDER: 'Vyhledat existující interaktivitu',
    REFRESH_PAGE: 'Obnovit stránku',
    EXTERNAL_LINK: 'Externí odkaz',
    STAND_MARKER1: 'Ikona (Přiblíženo)',
    STAND_MARKER2: 'Ikona (Oddáleno)',
    LOAD_FROM_DETAIL: 'Načíst z detailu',
    DISPLAY_IN_RECTANGLE: 'Zobrazit v obdélníku',
    COLORED_PIN: 'Barevná značka',
    CUSTOM_IMAGE: 'Vlastní obrázek',
    USE_IN_GUIDE: 'Použít v průvodci',
    LOCATION_NAME: 'Název místa',
    DETAILS: 'Detaily',
    PREVIEW: 'Náhled',
    UNSAVED_CHANGES: 'Neuložené změny',
    NO_TITLE: 'Bez názvu',
    SHOW_ON_ZOOM: 'Přiblížení (Zobrazit na mapě)',
    NO_EDIT_IN_MAP_EDITOR: 'Tento obsah nelze upravit v Map Editoru.',
    GLOBAL_POINTS_EDIT_NOT_SUPPORTED: 'Globální body nelze upravit. Upravte tento bod přímo ve svém CMS systému',
    NEWSFEED: 'Novinky',
    EDIT_NEWSFEED_MESSAGE: 'Upravit zprávu v novinkách',
    PC_WELCOME_MESSAGE: 'PC Vítejte zpráva',
    TEST_NEWSFEED_NOTIFICATION: 'Testovací notifikace',
    NEWSFEED_SELECT_USERS: 'Vyberte uživatele',
    NEWSFEED_SEND_TEST_NOTIFICATION: 'Odeslat testovací notifikaci',
    HEADER_IMAGE: 'Obrázek záhlaví',
    NAVIGATION_TITLE: 'Navigace',
    NAVIGATION_DESCRIPTION: 'Definujte, jak se uživatel pohybuje ve vaší aplikaci',
    NAVIGATION_LINK_DESTINATION: 'Cíl odkazu',
    NAVIGATION_EXTERNL_URL: 'Externí URL',
    NAVIGATION_SELECT_LIST: 'Vyberte seznam',
    NAVIGATION_SELECT_FORM: 'Vyberte formulář',
    NAVIGATION_SHOW_DYNAMIC_NUMBER: 'Zobrazit dynamické číslo',
    NAVIGATION_CUSTOM_ICON: 'Vlastní ikona',
    NAVIGATION_CUSTOM_TITLE: 'Vlastní název',
    NAVIGATION_DRAWER_HELP: 'Zásuvka je rozdělena na primární (velké) a sekundární (malé) tlačítka. Můžete nastavit, kolik tlačítek je primárních',
    NEWSFEED_CREATE_NEW_MESSAGE: 'Vytvořit novou zprávu',
    NEWSFEED_HELP: 'Aktualizace, které můžete sdílet se svými návštěvníky. Zprávy jsou viditelné v sekci Novinky a uživatelé jsou o nich informováni prostřednictvím Push notifikací',
    NEWSFEED_REMOVE_CONFIRM: 'Opravdu chcete odstranit zprávu v novinkách?',
    NEWSFEED_SEND_TO_ALL_CONFIRM: 'Opravdu chcete odeslat notifikaci všem uživatelům aplikace?',
    NEWSFEED_NOTIFICATIONS: 'Notifikace',
    NEWSFEED_NOTIFICATIONS_SENT: 'Notifikace odeslány',
    ROOMS: 'Místnosti',
    VARIANT_ICON: 'Variantní ikona',
    LIST_VIEW_TYPE: 'Typ zobrazení seznamu',
    CREATE_FORM: 'Vytvořit formulář',
    EDIT_FORM: 'Upravit formulář',
    FORM_TITLE: 'Název formuláře',
    FORM_THANK_YOU_MESSAGE: 'Děkujeme zpráva',
    FORM_ALLOW_MULTIPLE_SUBMISSIONS: 'Povolit více odeslání',
    FORM: 'Formulář',
    FORM_FIELDS: 'Pole',
    FORM_FIELD_TITLE: 'Název pole',
    FORM_FIELD_TEXT: 'Text pole',
    FORM_OPTIONS: 'Možnosti',
    REQUIRED: 'Povinné',
    EXTERNAL_POINTS: 'Externí body',
    EXTERNAL_POINTS_DESCRIPTION: 'Přidat externí body z vašeho CMS',
    ENABLE_HIGHLIGHTED_CATEGORY: 'Povolit zvýrazněnou kategorii',
    TOP_LEFT: 'Nahoře vlevo',
    BOTTOM_RIGHT: 'Dole vpravo',
    INITIAL_POSITION: 'Počáteční pozice',
    ZOOM_SETTINGS: 'Nastavení zoomu',
    VISIBLE_IN: 'Viditelné v',
    MAP_ORIENTATION: 'Orientace mapy',
    MIN_MAX_ZOOM: 'Min/Max zoom',
    CURRENT_VIEW_INFO: 'Informace o aktuálním zobrazení',
    CURRENT_ZOOM: 'Aktuální zoom',
    LAST_CLICK: 'Poslední kliknutí',
    GLOBAL_MARKER_SETTINGS: 'Globální nastavení značky',
    PIN_SETTINGS: 'Nastavení značky',
    TEXT_COLOR: 'Barva textu',
    BACKGROUND_COLOR: 'Barva pozadí',
    AUTO_HIDE_LABELS: 'Automaticky skrýt popisky',
    MARKER_GROUPING: 'Seskupení značek',
    MAX_CLUSTERING_ZOOM: 'Maximální seskupování',
    CLUSTER_RADIUS: 'Poloměr seskupení',
    SHOW_LIST_OF_DETAILS: 'Zobrazit seznam detailů',
    NO_LIST: 'Bez seznamu',
    SHOW_LIST: 'Zobrazit seznam',
    SHOW_LIST_WITH_SEARCH: 'Zobrazit seznam s vyhledáváním',
    HOME: 'Domů',
    MAP: 'Mapa',
    PROGRAMME_SHORT: 'Program',
    SPEAKERS: 'Řečníci',
    INFO: 'Info',
    MAP_VIEW: 'Zobrazení mapy',
    REMOVE_FILTERS: 'Odstranit filtry',
    LIST_VIEW: 'Zobrazení seznamu',
    GUIDANCE: 'Průvodce',
    HIGHLIGHTED: 'Zvýrazněné',
    EXHIBITORS: 'Vystavovatelé',
    SURVEY: 'Dotazník',
    OPEN_ON_YOUR_PHONE: 'Otevřít na telefonu',
    INTERACTIVE_MAP: 'Interaktivní mapa',
    SHOW_MORE: 'Zobrazit více',
    LINKS: 'Odkazy',
    FORM_SUBMIT: 'Odeslat formulář',
    FORM_SUBMITTED: 'Formulář byl úspěšně odeslán',
    INVALID_VALUE: 'Neplatná hodnota',
    COMPANIES: 'Firmy',
    LIST: 'List',
    FILTERS: 'Filtry',
    ZOOM: 'Zoom',
    HIGHLIGHT: 'Zvýraznit',
    UNHIGHLIGHT: 'Zrušit',
    WEBSITE: 'Stránka',
    PREVIOUS: 'Předchozí',
    NEXT: 'Další',
    SHOW_ON_MAP: 'Zobrazit na mapě',
    CLOSE: 'Zavřít',
    SHOW_ALL: 'Zobrazit vše',
    HIDE_ALL: 'Skrýt vše',
    PROGRAMME: 'Program',
    PLACES: 'Místa',
    THIS_IS_INTERACTIVE_MAP: 'Toto je interaktivní mapa',
    CLICK_ON_INFO: 'Klikněte na značky pro více informací',
    CONTINUE: 'Pokračovat',
    MAPBOX_SCROLL_ZOOM_BLOCKER_CTRL: 'Použijte ctrl + scroll pro zoom mapy',
    MAPBOX_SCROLL_ZOOM_BLOCKER_COMMAND: 'Použijte ⌘ + scroll pro zoom mapy',
    SUBMIT_AGAIN: 'Odeslat znovu',
    OTHER_ITEMS: 'Další',
    MAIN_H1: 'Vytvořte si interaktivní mapu za minutu',
    MAIN_H2: 'Sdílejte, Embeddujte, Prodávejte. Jak jen chcete. Bez registrace',
    YOUR_POSSIBILITIES: 'Vaše možnosti',
    GET_YOUR_INSPIRATION: 'Získejte inspiraci',
    NAME_YOUR_MAP: 'Pojmenujte svou mapu',
    AGREE_WITH: 'Souhlasím s',
    TERMS_AND_CONDITIONS: 'podmínkami',
    CREATE_YOUR_MAP: 'Vytvořte si mapu',
    HERO_BLOCK1_H1: 'Vyberte si styl',
    HERO_BLOCK1_P1: 'Vyberte si styl mapy, který se vám líbí. Na výběr je mnoho různých stylů, které vyhovují vašim potřebám a odpovídají vaší značce. Můžete dokonce nahrát vlastní mapu jako obrázek a přidat na ni interaktivní značky',
    HERO_BLOCK2_H1: 'Přidejte libovolné značky',
    HERO_BLOCK2_P1: 'Předveďte svou kreativní stránku. Do mapy můžete přidávat značky, jako jsou špendlíky, obrázky, tvary, cesty a čáry. K dispozici je také připravená knihovna obrázků a ikon generovaných umělou inteligencí, ze které si můžete vybrat',
    HERO_BLOCK3_H1: 'Udělejte to interaktivní',
    HERO_BLOCK3_P1: 'Každá značka, kterou na mapu umístíte, může být interaktivní. Když na ni návštěvníci kliknou, zobrazí se jim váš text, obrázky, odkazy, videa a další. Tímto způsobem jim můžete snadno poskytnout další hodnotu',
    TRAVELLING: 'Cestování',
    CABIN_MAP: 'Mapa chat',
    CITY_MAP: 'Městská mapa',
    FOOD_FESTIVAL: 'Festival jídla',
    FESTIVALS: 'Festivaly',
    MUSIC_FESTIVAL: 'Hudební festival',
    FAIRS: 'Trhy',
    JOB_FAIR: 'Veletrh práce',
    THEME_PARKS: 'Zábavní parky',
    FAMILY_PARK: 'Rodinný park',
    CONFERENCES: 'Konference',
    CONFERENCE: 'Konference',
    BUSINESS: 'Podnikání',
    CUSTOMER_MAP: 'Mapa zákazníků',
    SPORT: 'Sport',
    RUNNING_RACE: 'Běžecký závod',
    TRONDHEIM_NORWAY: 'Trondheim, Norsko',
    GOTA_FAROE_ISLANDS: 'Gota, Faerské ostrovy',
    TYDAL_NORWAY: 'Tydal, Norsko',
    LIBEREC_CZECHIA: 'Liberec, Česko',
    AGDER_NORWAY: 'Agder, Norsko',
    AARHUS_DENMARK: 'Aarhus, Dánsko',
    NAMSSKOGAN_NORWAY: 'Namsskogan, Norsko',
    HEMSEDAL_NORWAY: 'Hemsedal, Norsko',
    BRNO_CZECHIA: 'Brno, Česko',
    CHOOSE_YOUR_STYLE: 'Vyberte si styl',
    CLASSIC: 'Klasický',
    SATELLITE: 'Satelitní',
    OUTDOORS: 'Venkovní',
    DARK: 'Tmavý',
    LIGHT: 'Světlý',
    COLORED: 'Barevný',
    IMAGE_MAP: 'Obrázková mapa',
    UPLOADING: 'Nahrávání',
    BACK: 'Zpět',
    I_LIKE_THIS_ONE: 'Tento se mi líbí',
    CONGRAT_TITLE: 'Gratulujeme, vaše mapa je vytvořena!',
    CONGRAT_DESC: 'Nyní přidejte nějaké značky, abyste ukázali svá místa',
    MARKER_SELECTION: 'Výběr značky',
    MARKER_SELECTION_DESC: 'Vyberte značky zespodu',
    STYLING: 'Úpravy',
    STYLING_DESC: 'Nastylujte značky vpravo',
    START_ACTION: 'Začněte přidávat značky',
    CREATING_PROMPT1: 'Ahoj!',
    CREATING_PROMPT1_DESC: 'Vytváříte skvělou mapu! Neztraťte ji, když odejdete. Vytvořte si nyní účet zdarma',
    CREATING_PROMPT2: 'Chcete více funkcí?',
    CREATING_PROMPT2_DESC: 'Přidejte se na naši čekací listinu a buďte mezi prvními, kteří získají více funkcí!',
    JOIN_ACTION: 'Připojit se',
    ALREADY_CREATING: 'Už vytváříte mapu',
    CONTINUE_CREATING: 'Pokračovat v tvorbě',
    ALL: 'Vše',
    EAT: 'Jíst',
    EXPLORE: 'Prozkoumat',
    EXPERIENCE: 'Vyzkoušet',
    LEARN: 'Naučit',
    LANDING_TITLE: 'Vítejte v editoru Mapheim! (Beta)',
    LANDING_DESCRIPTION: 'Máte 2 možnosti tvorby. Buď můžete vytvořit kompletní řešení (webová aplikace s volitelnou interaktivní mapou). Nebo můžete vytvořit a používat samotnou interaktivní mapu',
    LANDING_ITEM1: 'Vyberte, co chcete vytvořit',
    LANDING_ITEM2: 'Dejte nám vědět, pokud máte nějaké dotazy nebo zpětnou vazbu',
    LANDING_ITEM3: 'Doporučujeme se přihlásit, abyste nepřišli o svou tvorbu!',
    GUIDES: 'Průvodci',
    GUIDES_DESC: 'Aplikace s volitelnou interaktivní mapou',
    EDIT_GUIDE_NO_LOGIN: 'Úprava průvodce bez přihlášení',
    CREATE_GUIDE_NO_LOGIN: 'Vytvořte průvodce bez přihlášení',
    NEW_GUIDE_TITLE: 'Nový průvodce',
    NEW_MAP_TITLE: 'Nová mapa',
    NEW_GUIDE_MESSAGE: 'Naskenujte QR kód pro přístup k aplikaci na vašem mobilu. Můžete si tak užít událost naplno',
    INTERACTIVE_MAPS: 'Interaktivní mapy',
    INTERACTIVE_MAPS_DESC: 'Samostatná interaktivní mapa',
    EDIT_MAP_NO_LOGIN: 'Úprava mapy bez přihlášení',
    CREATE_MAP_NO_LOGIN: 'Vytvořte mapu bez přihlášení',
    CREATE_GUIDE: 'Vytvořit průvodce',
    GUIDE_NAME: 'Název průvodce',
    ACTIONS: 'Akce',
    MAP_NAME: 'Název mapy',
    EDIT_MAP: 'Upravit mapu',
    EDIT_DETAILS: 'Upravit detaily',
    CREATE_MAP: 'Vytvořit mapu',
    CONFIGURATION: 'Konfigurace',
    LISTS: 'Seznamy',
    PROGRAM: 'Program',
    SHARE: 'Sdílet',
    CONFIGURATION_TITLE: 'Vítejte v editoru (Beta)',
    CONFIGURATION_DESC: 'Nastavte si svou aplikaci a/nebo interaktivní mapu během několika okamžiků',
    CONFIGURATION_ITEM1: 'Vyplňte základní informace',
    CONFIGURATION_ITEM2: 'Vyberte si které funkce chcete mít ve svém řešení',
    CONFIGURATION_ITEM3: 'Vše v editoru se ukládá automaticky',
    CONFIGURATION_ITEM4: 'Kontaktujte nás pro jakékoliv dotazy a zpětnou vazbu',
    BASIC_INFORMATION: 'Základní nastavení',
    BASIC_INFORMATION_DESC: 'První kroky pro vaši skvělou aplikaci!',
    FEATURES: 'Funkce',
    FEATURES_DESC: 'Co byste chtěli mít ve své aplikaci?',
    OTHER_INFORMATION: 'Další informace',
    EXTERNAL_LINKS: 'Externí odkazy',
    EXTERNAL_LINKS_DESC: 'Odkazy vedoucí návštěvníky mimo aplikaci',
    CUSTOM_FEATURES: 'Funkce na zakázku a pomoc',
    CUSTOM_FEATURES_DESC: 'Kontaktujte nás pro více možností vašeho řešení, například:',
    CUSTOM_FEATURES_ITEM1: 'Vaše barevné schéma a branding',
    CUSTOM_FEATURES_ITEM2: 'Další funkce a konfigurace',
    CUSTOM_FEATURES_ITEM3: 'Pomoc a podpora s tvorbou',
    INFORMATION: 'Informace',
    WELCOME_MESSAGE: 'Uvítací zpráva',
    COLOR_THEME: 'Barevné schéma',
    LOGO: 'Logo',
    LISTS_DESC2: 'Seznamy bodů zájmu (např. Vystavovatelé, Zvířata, Restaurace)',
    PROGRAM_DESC: 'Program akcí během dne',
    INFO_DESC: 'Klasická sekce otázek a odpovědí',
    MAP_DESC: 'Vnitřní nebo venkovní interaktivní mapa',
    OPEN_ACTION: 'Otevřít',
    START_DATE: 'Datum začátku',
    END_DATE: 'Datum konce',
    MAP_PREVIEW: 'Náhled mapy',
    DATES: 'Datumy',
    VISUAL: 'Vizuální',
    ASK_REMOVE_LINK: 'Chcete smazat tento odkaz?',
    URL: 'URL',
    MESSAGE: 'Zpráva',
    SEND_EMAIL: 'Odeslat email',
    EMAIL_SENT1: 'Email odeslán!',
    EMAIL_SENT2: 'Něco se pokazilo',
    EMAIL_SENT1_DESC: 'Ozveme se vám co nejdříve',
    EMAIL_SENT2_DESC: 'Prosím zkuste to znovu nebo nás kontaktujte pomocí bubliny v rohu',
    CLONE_GUIDE: 'Klonovat průvodce',
    CLONING: 'Klonování',
    CLONE_MESSAGE: 'Všechen obsah průvodce bude zkopírován, včetně mapy. Váš aktuální průvodce nebude ovlivněn. Chcete tohoto průvodce naklonovat?',
    DELETE_GUIDE: 'Smazat průvodce',
    DELETING: 'Mazání',
    DELETE_MESSAGE: 'Tato akce je nevratná. Váš obsah, včetně mapy bude smazán. Jste si jisti, že chcete smazat tohoto průvodce?',
    CANCEL: 'Zrušit',
    CONFIRM: 'Potvrdit',
    NEW_DETAIL: 'Nový detail',
    DETAIL_CREATED: 'Detail vytvořen!',
    CATEGORY_CREATED: 'Kategorie vytvořena!',
    DONE: 'Hotovo',
    DETAILS_TITLE: 'Upravte své detaily',
    DETAILS_DESC: 'Toto je místo, kde můžete přidat všechny detaily pro vaši aplikaci. Vyplňte data (text, obrázky, odkazy, atd.) pro vaše Seznamy, Program, Informace a Mapu. Poté je můžete propojit na dalších stránkách.',
    DETAILS_ITEM1: 'Přidejte všechny detaily pro vaši aplikaci',
    DETAILS_ITEM2: 'Přidejte kategorie pro použití filtrů',
    DETAILS_DESC2: 'Přidejte všechny detaily pro vaši aplikaci',
    CREATING: 'Vytváření',
    CREATE_DETAIL: 'Vytvořit detail',
    NOT_USED: 'Nepoužito',
    FILTER: 'Filtr',
    CREATE_CATEGORY: 'Vytvořit kategorii',
    CATEGORIES_DESC: 'Přidejte kategorie pro použití filtrů (např. "Typy vystavovatelů", "Různé místnosti", atd.)',
    ASK_DELETE_DETAIL: 'Chcete smazat tento detail?',
    USAGE: 'Použití',
    ASK_DELETE_CATEGORY: 'Chcete smazat tuto kategorii?',
    QUICK_ASSIGN_LISTS: 'Rychlé přiřazení k Seznamům a Informacím',
    EDIT_CATEGORIES: 'Upravit kategorie',
    NO_CATEGORIES: 'Nebyly nalezeny žádné kategorie. Nejdříve je vytvořte v Detailech',
    GO_TO_DETAILS: 'Jít do Detailů',
    EDIT_CATEGORY: 'Upravit kategorii',
    BACK_TO_DETAILS: 'Zpět do Detailů',
    EDIT_DETAIL: 'Upravte tento detail',
    EDIT_DETAIL_DESC: 'Vyplňte informace pro tento detail. Nezapomeňte přidat mnoho karet, aby byl zajímavější a relevantnější pro vaše návštěvníky.',
    EDIT_DETAIL_ITEM1: 'Vyplňte záhlaví: Název, popis a obrázek',
    EDIT_DETAIL_ITEM2: 'Přidejte mnoho karet s rozmanitým obsahem (odkazy, obrázky, videa, atd.)',
    EDIT_DETAIL_ITEM3: 'Podívejte se na náhled vpravo, abyste viděli jak to vypadá',
    EDIT_DETAIL_ITEM4: 'Vše se ukládá automaticky',
    HEADER_DETAIL: 'Záhlaví',
    HEADER_DETAIL_DESC: 'Přidejte základní informace pro tento detail. Nezapomeňte přidat nějaké karty po tomto',
    CONTENT_DETAIL: 'Obsah',
    CONTENT_DETAIL_DESC: 'Vyberte si z mnoha karet pro přidání rozmanitého obsahu do tohoto detailu',
    LIVE_PREVIEW: 'Živý náhled',
    STRETCH_IMAGE: 'Roztáhnout obrázek',
    GIF_CARD: 'GIF karta',
    ASK_DELETE_IMAGE: 'Chcete smazat tento obrázek?',
    IMAGE_CARD: 'Obrázková karta',
    LINK_CARD: 'Odkazová karta',
    LINKED_STORIES_CARD: 'Karta propojených detailů',
    TEXT_CARD: 'Textová karta',
    ASK_DELETE_CARD: 'Chcete smazat tuto kartu?',
    OPEN_YOUTUBE: 'Otevřít YouTube',
    OPEN_FACEBOOK: 'Otevřít Facebook',
    OPEN_TWITTER: 'Otevřít Twitter',
    OPEN_INSTAGRAM: 'Otevřít Instagram',
    CREATE_LISTS_TITLE: 'Vytvořte různé seznamy detailů',
    CREATE_LISTS_DESC: 'Můžete vytvořit jeden nebo více seznamů, jako jsou restaurace, obchody, vystavovatelé, atd. Přiřaďte detaily do seznamů',
    CREATE_LISTS_ITEM1: 'Vytvořte seznamy detailů',
    CREATE_LISTS_ITEM2: 'Nastavte jejich vlastnosti',
    CREATE_LISTS_ITEM3: 'Přiřaďte detaily do seznamů',
    LISTS_DESC: 'Spravujte vlastnosti a detaily ve vašich seznamech',
    CREATE_LIST: 'Vytvořit seznam',
    THIS_PREVIEW: 'Toto je náhled',
    THIS_PREVIEW_DESC: 'Otevřete na svém telefonu živě',
    OPEN_IN_TAB: 'Otevřít v nové kartě',
    ASK_DELETE_LIST: 'Chcete smazat tento seznam?',
    LINKED_DETAILS: 'Připojené detaily',
    LINK_DETAILS: 'Připojit detaily',
    NO_DETAILS: 'Nejsou žádné detaily k připojení. Nejdříve je vytvořte v Detailech',
    SEARCH_DETAILS: 'Hledat detaily',
    NO_OPTIONS: 'Žádné možnosti',
    EDIT_LIST: 'Upravit seznam',
    LINK_TEXT: 'Text odkazu',
    LINK_URL: 'URL odkazu',
    LINK_TO_MAP: 'Odkaz na mapu',
    SEARCHABLE: 'Vyhledávání',
    MODIFY_PROGRAM: 'Upravte program',
    MODIFY_PROGRAM_DESC: 'Přidejte, upravte nebo smažte události v programu. Můžete jim přiřadit kategorie, propojit je s detaily nebo znakou na mapě',
    MODIFY_PROGRAM_ITEM1: 'Přidejte položky programu',
    MODIFY_PROGRAM_ITEM2: 'Přiřaďte detaily k jednotlivým položkám programu',
    MODIFY_PROGRAM_ITEM3: 'Propojte je se značkou na mapě',
    EVENTS: 'Události',
    EVENTS_DESC: 'Spravujte události a jejich detaily',
    CREATE_EVENT: 'Vytvořit událost',
    ASK_REMOVE_EVENT: 'Chcete smazat tuto událost?',
    IN_MAP: 'Na mapě',
    DATE: 'Datum',
    EDIT_EVENT: 'Upravit událost',
    AUTOFILL_INFO: 'Vyplňte název a popis z připojeného detailu',
    TIME_START: 'Čas začátku',
    TIME_END: 'Čas konce',
    MAP_LOCATION: 'Lokace na mapě',
    SELECT_MARKER: 'Vyberte značku',
    NO_MAP_LOCATIONS: 'Nebyly nalezeny žádné lokace na mapě. Nejdříve je vytvořte v Mapě',
    GO_TO_MAP: 'Jít do Mapy',
    MODIFY_INFORMATION: 'Upravte informace',
    MODIFY_INFORMATION_DESC: 'Provázejte své návštěvníky poskytnutím otázek a odpovědí. Každé téma je propojený detail',
    MODIFY_INFORMATION_ITEM1: 'Přiřaďte detaily do sekce informací',
    INFORMATION_DESC: 'Přiřaďte detaily k zobrazení v sekci informací',
    CREATE_MAP_TITLE: 'Vytvořte interaktivní mapu',
    CREATE_MAP_DESC: 'Máte možnost mít skvělou interaktivní mapu pro vaše návštěvníky. Může být geografická, vnitřní, umělecká nebo založená na obrázku. Mapu můžete vytvořit v našem editoru, ale obvykle s tím pomáháme našim zákazníkům.',
    CREATE_MAP_ITEM1: 'Kontaktujte nás pro požadavky na mapu nebo upravte mapu v editoru',
    INTERACTIVE_MAP_DESC: 'Editor mapy se otevře v nové kartě',
    OPEN_EDITOR: 'Otevřít editor',
    SHARE_APPLICATION: 'Sdílejte vaši aplikaci',
    SHARE_APPLICATION_DESC: 'Můžete sdílet vaši aplikaci buď pomocí odkazu nebo QR kódu. Mapu můžete také přímo zahrnout do vašich webových stránek nebo aplikace.',
    SHARE_APPLICATION_ITEM1: 'Vytiskněte QR kódy a umístěte je do vaší oblasti nebo na vaše materiály',
    SHARE_APPLICATION_ITEM2: 'Sdílejte odkaz na vašich webových stránkách a sociálních sítích',
    SHARE_THE_APPLICATION: 'Sdílejte aplikaci',
    SHARE_THE_APPLICATION_DESC: 'Distribuujte QR kódy a odkazy vašim návštěvníkům',
    COPY_LINK: 'Kopírovat odkaz',
    COPY: 'Kopírovat',
    OPEN_LINK: 'Otevřít odkaz',
    DOWNLOAD_QR: 'Stáhnout QR kód',
    QR_CODE: 'QR kód',
    EMBEDDED_MAP_IFRAME: 'Vložená mapa iframe',
    FORMS: 'Formuláře',
    FORM_SUBMISSIONS: 'Odeslané formuláře',
    FORMS_DESC: 'Připojte formuláře k vašim průvodcům',
    MAP_V2_SEARCH_THIS_MAP: 'Vyhledat na mapě',
    MAP_V2_COLLAPSE: 'Sbalit',
    MAP_V2_EXPAND: 'Rozbalit',
    MAP_V2_GO_BACK: 'Jít zpět',
    MAP_V2_GOOGLE_MAPS_NAVIGATION: 'Navigace Google Maps',
    MAP_V2_ALL_PLACES: 'Všechna místa',
    MAP_V2_SELECTED_GROUP: 'Vybraná skupina',
    MAP_V2_CATEGORY_SHOW_ALL: 'Zobrazit vše',
    MAP_V2_CATEGORY_HIGHLIGHTS: 'Zvýrazněné',
    MAP_V2_CATEGORY_HERITAGE: 'Památky',
    MAP_V2_CATEGORY_DINING: 'Stravování',
    MAP_V2_CATEGORY_FUN: 'Zábava',
    MAP_V2_CATEGORY_ART: 'Umění',
    MAP_V2_CATEGORY_EVENTS: 'Události',
    MAP_V2_PLACES_POSTFIX: 'míst',
    MAP_V2_FULLSCREEN_TURN_OFF: 'Ukončit celou obrazovku',
    MAP_V2_FULLSCREEN_TURN_ON: 'Přepnout mapu do celé obrazovky'
};
